module.exports = __webpack_public_path__ + "img/search.408d74ca.png";